import React from 'react';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogTitle,
} from 'material-ui/Dialog';
import {Button} from 'material-ui';
import ImageMetaFields from './ImageMetaFields';

class ImageEditMetaDialog extends React.Component {
    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.handleClose}
                fullScreen
                classes={{
                    paper: this.props.classes.paper,
                }}
            >
                <DialogTitle>Edit Image Meta</DialogTitle>
                <DialogContent>
                    {this.props.image && (
                        <img
                            src={this.props.image.url}
                            className={this.props.classes.imageEdit}
                            alt="Projects Abroad Staff"
                        />
                    )}
                    <ImageMetaFields
                        classes={this.props.classes}
                        imageMeta={this.props.imageMeta}
                        setAltField={this.props.setAltField}
                        setTitleField={this.props.setTitleField}
                        setDescriptionField={this.props.setDescriptionField}
                        setLinkField={this.props.setLinkField}
                        setNameField={this.props.setNameField}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={this.props.handleCancel}
                        variant="raised"
                        className={this.props.classes.button}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={this.props.handleSubmit}
                        color="primary"
                        variant="raised"
                        className={this.props.classes.button}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default ImageEditMetaDialog;



// WEBPACK FOOTER //
// ./src/containers/staff/forms/ImageEditMetaDialog.jsx